export default __webpack_public_path__ + "img/upload-avatar-placeholder-add-icon.fde4fa13.svg";